/* --------------------------------------------------------------------------------------
   textboxPopup.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const textboxPopupComponent = {
  template: `
  <div xw-popup custom-action-bar="#textbox-popup-action-bar" display="vm.display">
    <div class="custom-action-bar-popup">
      <input type="text" class="full-width-popup-textbox" xw-keyboard initial-placeholder="vm.placeholder"></input>
    </div>
  </div>
  <action-bar id="textbox-popup-action-bar" title="{{vm.title}}" cancel="vm.cancel()"></action-bar>
  `,
  controllerAs: 'vm',
  controller: class textboxPopupCtrl {
    /*@ngInject*/
    constructor(appSettings, commonService) {
      this.appSettings = appSettings
      this.commonService = commonService
    }
    cancel() {
      this.display = false
      this.commonService.updateView()
    }
  },
  bindings: {
    title: '@',
    placeholder: '@',
    ok: '&',
    display: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/textboxPopup.component.js